"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    rpc: {},
    types: {
        ListingLevel: {
            _enum: {
                Global: 'Null',
                Local: 'MetaverseId'
            }
        },
        AuctionItem: {
            itemId: 'ItemId',
            recipient: 'AccountId',
            initialAmount: 'Balance',
            amount: 'Balance',
            startTime: 'u32',
            endTime: 'u32',
            auctionType: 'AuctionType',
            listingLevel: 'ListingLevel',
            currencyId: 'FungibleTokenId'
        },
        AuctionInfo: {
            bid: 'Option<(AccountId,Balance)>',
            start: 'BlockNumber',
            end: 'Option<BlockNumber>'
        },
        AuctionType: {
            _enum: ['Auction', 'BuyNow']
        }
    }
};
